import { AuthPage } from "@refinedev/mui";
import { zodResolver } from "@hookform/resolvers/zod";

import { loginSchema } from "@modules/auth/validations/loginSchema";

export const Login = () => {
  return (
    <AuthPage
      title={
        <>
          <img
            src={"/images/logo.png"}
            alt="Logo"
            style={{ width: "150px", height: "auto" }}
          />
        </>
      }
      type="login"
      registerLink={false}
      forgotPasswordLink={false}
      rememberMe={false}
      formProps={{
        resolver: zodResolver(loginSchema),
        defaultValues: {
          email: "",
          password: "",
        },
      }}
    />
  );
};
